// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_minhaBibliotecaAluno {
  margin: 1.9em;
  height: 100%;
}

h1 {
  font-weight: bold;
  font-family: "Roboto";
  font-size: 22px;
  margin-bottom: 9px;
  color: var(--cor-pretoForte);
}`, "",{"version":3,"sources":["webpack://./src/paginas/aluno/MinhaBibliotecaAluno.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B","sourcesContent":[".container_minhaBibliotecaAluno {\n  margin: 1.9em;\n  height: 100%;\n}\n\nh1 {\n  font-weight: bold;\n  font-family: \"Roboto\";\n  font-size: 22px;\n  margin-bottom: 9px;\n  color: var(--cor-pretoForte);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
